import { PropsOf } from "@emotion/react";
import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import { useIsMobile } from "hooks/useDeviceType";

interface BadgeProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
}

export const Badge = ({ icon, text, ...props }: BadgeProps & PropsOf<typeof Container>) => {
  const Icon = icon;
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 18 : 40;

  return (
    <Container {...props}>
      <Icon width={iconSize} height={iconSize} />
      <Text textStyle="Title" size="Large" shouldScale={true}>
        {text}
      </Text>
    </Container>
  );
};

// Sub-components

const Container = styled.div(({ theme }) => ({
  display: "flex",
  padding: "8px 24px 8px 16px",
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  color: theme.button.secondary.text.default,
  backgroundColor: "white",
  width: "fit-content",
  borderRadius: 24,
}));
